// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2K8OZ","title":"AfterBackImages_title__1_I-u","images":"AfterBackImages_images__1I3Dq"};